import styled from '@emotion/styled';
import { FileReference } from '@kaizenplatform/belfast-entity';
import { ClassAttributes, createElement, Fragment } from 'react';

import { DynamicSchemaDefinitionFiles } from '../../../../../generated/graphql';
import { FileListContainer } from '../../FileList';
import Base from './Base';

interface Props {
  field: Pick<DynamicSchemaDefinitionFiles, 'label'>;
  bucketId: string;
  files: FileReference[];
  beforeBucketId: string;
  latestBucketId: string;
  beforeFiles: FileReference[];
  latestFiles: FileReference[];
  className?: string;
}

const AsFiles = ({ field, beforeFiles, latestFiles, className }: Props & ClassAttributes<HTMLElement>) => {
  return (
    <Base field={field} className={className}>
      {JSON.stringify(beforeFiles) === JSON.stringify(latestFiles) ? (
        <Value>
          <FileListContainer files={latestFiles} />
        </Value>
      ) : (
        <>
          <Before>
            <FileListContainer files={beforeFiles} />
          </Before>

          <After>
            <FileListContainer files={latestFiles} />
          </After>
        </>
      )}
    </Base>
  );
};

const Value = styled('div')({});

const Before = styled('div')({
  padding: '4px',
  marginBottom: '4px',
  background: '#fdd7d5',
});

const After = styled('div')({
  padding: '4px',
  marginTop: '4px',
  background: '#c8ffd8',
});

export default AsFiles;
